<template>
    <div class="basic_wrap">
        <!-- 顶部标题 -->
        <div class="withdraw_header">
            <div class="back_left" @click="$router.back()">
                <img src="../../../src/assets/images/return.png" alt="">
            </div>
            <div class="big_tit">{{ $t('cash.UserWithdrawal') }}</div>
        </div>

        <!-- 用户银行卡信息卡片 -->
        <div class="user_card">
            <div class="user_id" v-if="bankCardInfo">{{ formatBankAccount(bankCardInfo.account || bankCardInfo.bank_account) }}</div>
            <div class="user_id" v-else>{{ userId }}</div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main_content">
            <!-- 未审核提示 -->
            <div v-if="hasPendingWithdraw" class="pending_warning">
                <span class="warning_icon">⚠️</span>
                <span class="warning_text">{{$t('user.pendingWithdrawWarning')}}</span>
            </div>
            
            <!-- 目前金额 -->
            <div class="info_row line_bottom">
                <div class="info_label">{{ $t('cash.CurrentAmount') }}</div>
                <div class="info_value">{{ currentBalance }}</div>
            </div>

            <!-- 选择提款账户 -->
            <div class="info_row line_bottom" @click="showBankCardPicker = !showBankCardPicker">
                <div class="info_label">{{$t('user.withdrawalAccount')}}</div>
                <div class="info_value select_value">
                    <span v-if="selectedBankCard">{{ selectedBankCard.payment_type }} ({{ getDisplayAddress(selectedBankCard) }})</span>
                    <span v-else class="placeholder">請選擇提款賬戶</span>
                    <span class="arrow_down" :class="{ 'arrow_up': showBankCardPicker }">▼</span>
                </div>
            </div>
            
            <!-- 银行卡下拉选择器 -->
            <div class="bank_card_dropdown" v-if="showBankCardPicker">
                <div 
                    v-for="card in bankCards" 
                    :key="card.id"
                    class="bank_card_option"
                    :class="{ 'selected': selectedBankCard && selectedBankCard.id === card.id }"
                    @click.stop="selectBankCard(card)"
                >
                    <div class="card_info">
                        <div class="card_type">{{ card.payment_type }}</div>
                        <div class="card_account">{{ getDisplayAddress(card) }}</div>
                    </div>
                    <div class="card_rate">汇率: {{ card.rate }}</div>
                </div>
            </div>

            <!-- 取款数量 -->
            <div class="info_row line_bottom">
                <div class="info_label">{{ $t('item.Qukuanshuliang') }}</div>
                <div class="info_value">
                    <input type="number" v-model="withdrawQuantity" @input="calculateWithdrawAmount" :placeholder="$t('item.QingshuruQukuanshuliang')" class="amount_input">
                </div>
            </div>

            <!-- 交易密码 -->
            <div class="info_row line_bottom">
                <div class="info_label">{{ $t('cash.TransactionPassword') }}</div>
                <div class="info_value">
                    <input type="password" v-model="transactionPassword" :placeholder="$t('cash.TransactionPassword')" class="password_input">
                </div>
            </div>

            <!-- 取款金额（计算得出） -->
            <div class="info_row line_bottom">
                <div class="info_label">{{$t('user.withdrawAmount')}}</div>
                <div class="info_value amount_result">{{ withdrawAmount }}</div>
            </div>

            <!-- 取款规则说明 -->
            <div class="withdraw_rules">
                            <div class="rule_item line_bottom2">
                <span class="rule_number">1、</span>
                <span class="rule_text">{{ $t('cash.MinimumAmountPerWithdrawal') }} ${{ withdrawConfig.minAmount }}</span>
            </div>
            <div class="rule_item line_bottom2">
                <span class="rule_number">2、</span>
                <span class="rule_text">{{ $t('cash.WithdrawalTimeDaily') }} {{ withdrawConfig.startTime }}:00:00-{{ withdrawConfig.endTime }}:00:00</span>
            </div>
            <div class="rule_item">
                <span class="rule_number">3、</span>
                <span class="rule_text">{{ $t('cash.WithdrawalFee') }} {{ withdrawConfig.feeRate }}%</span>
            </div>
            </div>

            <!-- 提交按钮 -->
            <div 
                class="submit_btn" 
                :class="{ 'disabled': isSubmitting || hasPendingWithdraw }"
                @click="submitWithdraw"
            >
                {{ isSubmitting ? '提交中...' : $t('login.submit') }}
            </div>
        </div>

        <!-- 底部导航栏 -->
        <FooterTab :activeType="'user'" />
    </div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'
import { Toast } from 'vant'

export default {
    name: "Withdraw",
    components: { FooterTab },
    data() {
        return {
            show_icon_type: 'index',
            currentBalance: '0.00',
            withdrawQuantity: '', // 取款数量
            withdrawAmount: '0.00', // 取款金额（计算得出）
            transactionPassword: '',
            userId: '',
            bankCardInfo: null, // 银行卡信息（兼容性保留）
            bankCards: [], // 所有银行卡列表
            selectedBankCard: null, // 选中的银行卡
            showBankCardPicker: false, // 是否显示银行卡选择器
            hasPendingWithdraw: false, // 是否有未审核的提款记录
            isSubmitting: false, // 是否正在提交中
            withdrawConfig: {
                minAmount: 100,
                feeRate: 1,
                startTime: 10,
                endTime: 22,
                description: '單次提現金額至少 $100，提現時間為每日 10:00-22:00，提現手續費 1%'
            }
        };
    },
    created() {
        this.$parent.footer("user", false);
        this.show_icon_type = 'index';
        // 从store获取用户余额
        this.getUserBalance();
        // 获取提现配置
        this.getWithdrawConfig();
        // 获取银行卡信息
        this.getBankCardInfo();
        // 检查是否有未审核的提款记录
        this.checkPendingWithdraw();
    },
    methods: {
        async getUserBalance() {
            // 优先从store获取，如果没有则调用API获取
            const balance = this.$store.getters.getUserBalance;
            const userInfo = this.$store.getters.getUserInfo;
            
            if (balance && balance !== '0.00' && userInfo) {
                this.currentBalance = balance;
                this.userId = userInfo.phone || userInfo.uid || userInfo.id || '';
            } else {
                // 如果store中没有数据，调用API获取最新数据
                try {
                    const result = await Fetch('/user/info');
                    if (result && result.code === 1) {
                        this.currentBalance = result.data.money || '0.00';
                        this.userId = result.data.mobile || result.data.uid || result.data.id || '';
                        
                        // 更新store中的数据
                        this.$store.commit('setUserInfo', result.data);
                        console.log('重新获取用户信息成功:', result.data);
                    } else {
                        console.error('获取用户信息失败:', result);
                    }
                } catch (error) {
                    console.error('获取用户信息出错:', error);
                }
            }
        },
        
        // 获取银行卡信息
        async getBankCardInfo() {
            try {
                console.log('获取银行卡信息');
                const result = await Fetch('/user/my_bank');
                console.log('银行卡信息获取结果:', result);
                
                if (result && result.code === 1 && result.data && result.data.bank && result.data.bank.length > 0) {
                    // 保存所有银行卡
                    this.bankCards = result.data.bank;
                    
                    // 默认选择第一张银行卡
                    this.selectedBankCard = this.bankCards[0];
                    this.bankCardInfo = this.bankCards[0]; // 兼容性保留
                    
                    console.log('银行卡列表:', this.bankCards);
                    console.log('默认选中:', this.selectedBankCard);
                } else {
                    console.log('没有银行卡信息');
                    this.bankCards = [];
                    this.selectedBankCard = null;
                    this.bankCardInfo = null;
                }
            } catch (error) {
                console.error('获取银行卡信息失败:', error);
                this.bankCards = [];
                this.selectedBankCard = null;
                this.bankCardInfo = null;
            }
        },
        
        // 获取显示地址（根据类型选择account或wallet_address）
        getDisplayAddress(card) {
            if (!card) return '******';
            
            // type=4是银行卡，显示account；其他类型是虚拟币，显示wallet_address
            const address = (card.type === 4) ? card.account : card.wallet_address;
            return this.formatBankAccount(address);
        },
        
        // 格式化银行卡号（隐藏中间部分）
        formatBankAccount(account) {
            if (!account) return '******';
            
            const str = String(account);
            
            // 直接返回，后端已经做了脱敏处理
            return str;
        },
        
        // 选择银行卡
        selectBankCard(card) {
            this.selectedBankCard = card;
            this.showBankCardPicker = false;
            
            // 重新计算取款金额
            this.calculateWithdrawAmount();
            
            console.log('选择银行卡:', card);
        },
        
        // 计算取款金额
        calculateWithdrawAmount() {
            if (!this.withdrawQuantity || !this.selectedBankCard) {
                this.withdrawAmount = '0.00';
                return;
            }
            
            const quantity = parseFloat(this.withdrawQuantity) || 0;
            const rate = parseFloat(this.selectedBankCard.rate) || 1;
            
            // 取款金额 = 取款数量 × 汇率
            const amount = quantity * rate;
            this.withdrawAmount = amount.toFixed(2);
            
            console.log('计算取款金额:', {
                取款数量: quantity,
                汇率: rate,
                取款金额: this.withdrawAmount
            });
        },

        
        // 检查是否有未审核的提款记录
        async checkPendingWithdraw() {
            try {
                const result = await Fetch('/user/cash_search');
                if (result.code === 1 && result.data) {
                    // 检查是否有status=0的记录（待审核）
                    const pendingRecords = result.data.filter(record => record.status === 0);
                    this.hasPendingWithdraw = pendingRecords.length > 0;
                    
                    if (this.hasPendingWithdraw) {
                        console.log('檢測到未審核的提款記錄:', pendingRecords);
                    }
                }
            } catch (error) {
                console.error('檢查提款記錄失敗:', error);
            }
        },
        
        // 获取提现配置
        async getWithdrawConfig() {
            try {
                console.log('獲取提現配置');
                const result = await Fetch('/user/withdraw_config');
                if (result.code === 1) {
                    this.withdrawConfig = result.data;
                    console.log('提現配置獲取成功:', this.withdrawConfig);
                } else {
                    console.error('獲取提現配置失敗:', result);
                }
            } catch (error) {
                console.error('獲取提現配置失敗:', error);
            }
        },
        async submitWithdraw() {
            // 防止重复提交
            if (this.isSubmitting) {
                Toast('提交中，請稍候...');
                return;
            }
            
            // 先重新检查一次是否有未审核的提款记录（实时检查）
            try {
                const checkResult = await Fetch('/user/cash_search');
                if (checkResult.code === 1 && checkResult.data) {
                    const pendingRecords = checkResult.data.filter(record => record.status === 0);
                    if (pendingRecords.length > 0) {
                        this.hasPendingWithdraw = true;
                        Toast(this.$t('user.pendingWithdrawWarning'));
                        return;
                    }
                    this.hasPendingWithdraw = false;
                }
            } catch (error) {
                console.error('檢查提款記錄失敗:', error);
            }
            
            // 检查是否有未审核的提款记录
            if (this.hasPendingWithdraw) {
                Toast(this.$t('user.pendingWithdrawWarning'));
                return;
            }
            
            // 表单验证
            if (!this.selectedBankCard) {
                Toast('請選擇提款賬戶');
                return;
            }
            
            if (!this.withdrawQuantity) {
                Toast('請輸入取款數量');
                return;
            }
            
            if (!this.transactionPassword) {
                Toast('請輸入交易密碼');
                return;
            }
            
            // 验证数量格式
            const quantity = parseFloat(this.withdrawQuantity);
            if (isNaN(quantity) || quantity <= 0) {
                Toast('請輸入有效的數量');
                return;
            }
            
            // 计算取款金额
            const amount = parseFloat(this.withdrawAmount);
            
            // 验证最小提現金額
            if (amount < this.withdrawConfig.minAmount) {
                Toast(`單次提現金額至少 $${this.withdrawConfig.minAmount}`);
                return;
            }
            
            // 验证提现时间
            const currentHour = new Date().getHours();
            if (currentHour < this.withdrawConfig.startTime || currentHour >= this.withdrawConfig.endTime) {
                Toast(`提现时间为每日 ${this.withdrawConfig.startTime}:00-${this.withdrawConfig.endTime}:00`);
                return;
            }
            
            // 验证余额是否充足
            const currentBalance = parseFloat(this.currentBalance);
            if (amount > currentBalance) {
                Toast('余额不足');
                return;
            }
            
            // 设置提交状态为正在提交
            this.isSubmitting = true;
            
            try {
                console.log('开始提现流程', {
                    取款数量: quantity,
                    取款金额: amount,
                    选中银行卡: this.selectedBankCard,
                    汇率: this.selectedBankCard.rate
                });
                
                // 调用提现API
                const submitData = {
                    money: amount,
                    passwd: this.transactionPassword,
                    bank_id: this.selectedBankCard.id
                };
                console.log('提现提交数据:', submitData);
                
                const result = await Fetch('/user/cost_apply', submitData);
                console.log('提现API返回结果:', result);
                
                if (result.code === 1) {
                    // 提现申请成功
                    Toast.success(result.info || '提现申请提交成功');
                    
                    // 设置为有未审核记录（提交成功后立即有待审核记录）
                    this.hasPendingWithdraw = true;
                    
                    // 清空表单
                    this.withdrawQuantity = '';
                    this.withdrawAmount = '0.00';
                    this.transactionPassword = '';
                    
                    // 更新用户余额
                    this.getUserBalance();
                    
                    // 重新检查未审核记录
                    this.checkPendingWithdraw();
                    
                    // 可选：跳转到提现记录页面
                    setTimeout(() => {
                        this.$router.push('/withdrawRecord');
                    }, 2000);
                } else {
                    // 处理业务错误
                    console.error('提现申请失败:', result);
                    if (result.info) {
                        if (typeof result.info === 'string') {
							if (result.info === 'HAS_ONGOING_LOAN') {
								errorMessage = this.$t('loan.hasOngoingLoan') || '您有正在进行中的贷款，请先处理完成后再申请';
								Toast(errorMessage);
							}else{
								Toast(result.info);
							}
                            
                        } else if (typeof result.info === 'object') {
                            const currentLang = localStorage.getItem('lang') || 'zh_hk';
                            const message = result.info[currentLang] || result.info.zh_cn || '提现申请失败';
                            Toast(message);
                        }
                    } else {
                        Toast('提现申请失败，请稍后重试');
                    }
                }
            } catch (error) {
                console.error('提现申请出错:', error);
                Toast('网络错误，请稍后重试');
            } finally {
                // 无论成功还是失败，都要重置提交状态
                this.isSubmitting = false;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.basic_wrap {
    // min-height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
}

/* 顶部标题 */
.withdraw_header {
    position: relative;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-bottom: 1px solid #f0f0f0;

    .back_left {
        position: absolute;
        left: 15px;
        cursor: pointer;

        img {
            width: 16px;
        }
    }

    .big_tit {
        font-size: 16px;
        font-weight: 500;
        color: #333;
    }
}

/* 用户信息卡片 */
.user_card {
    margin: 20px;
    height: 110px;
    background: url(../../../src/assets/images/card-bg.png) no-repeat center center;
    background-size: 100% 100%;
    border-radius: 12px;
    padding: 0 20px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    .user_id {
        color: #ffffff !important;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        position: absolute;
        top: 15px;
        left: 20%;
    }
}

/* 主要内容区域 */
.main_content {
    flex: 1;
    padding: 0 20px;
}

/* 未审核警告提示 */
.pending_warning {
    margin: 15px 0;
    padding: 12px 15px;
    background: #fff3e0;
    border-left: 4px solid #ff9800;
    border-radius: 4px;
    display: flex;
    align-items: center;
    
    .warning_icon {
        font-size: 20px;
        margin-right: 10px;
    }
    
    .warning_text {
        flex: 1;
        font-size: 14px;
        color: #e65100;
        line-height: 1.5;
    }
}

/* 信息行 */
.info_row {
    display: flex;
    align-items: center;
    padding: 15px 0;

    .info_label {
        font-size: 16px;
        color: #333;
        font-weight: 500;
        width: 33.33%;
    }

    .info_value {
        font-size: 16px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 66.67%;
    }
}

.line_bottom {
    border-bottom: 1px solid #f0f0f0;
}

/* 输入框样式 */
.amount_input,
.password_input {
    border: none;
    background: transparent;
    font-size: 16px;
    color: #333;
    text-align: left;
    width: 100%;

    &:focus {
        outline: none;
    }

    &::placeholder {
        color: #999;
    }
}

/* 选择框样式 */
.select_value {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 100%;
    
    .placeholder {
        color: #999;
    }
    
    .arrow_down {
        margin-left: 8px;
        font-size: 12px;
        color: #999;
        transition: transform 0.3s;
        
        &.arrow_up {
            transform: rotate(180deg);
        }
    }
}

/* 银行卡下拉选择器 */
.bank_card_dropdown {
    position: relative;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    margin: -10px 0 15px 0;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 10;
    
    .bank_card_option {
        padding: 15px;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: background-color 0.3s;
        
        &:hover {
            background-color: #f5f5f5;
        }
        
        &.selected {
            background-color: #e6f7ff;
            border-left: 3px solid #1890ff;
        }
        
        &:last-child {
            border-bottom: none;
        }
        
        .card_info {
            flex: 1;
            
            .card_type {
                font-size: 14px;
                font-weight: 500;
                color: #333;
                margin-bottom: 4px;
            }
            
            .card_account {
                font-size: 12px;
                color: #999;
            }
        }
        
        .card_rate {
            font-size: 12px;
            color: #1890ff;
            font-weight: 500;
        }
    }
}

/* 取款金额显示样式 */
.amount_result {
    font-size: 18px;
    font-weight: 600;
    color: #1890ff;
}

/* 取款规则说明 */
.withdraw_rules {
    margin: 30px 0;

    .rule_item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 15px;
        // border-bottom: 1px solid #ddd;
        padding-bottom: 10px;

        .rule_number {
            width: 20px;
            height: 20px;
            // background: #1890ff;
            // color: #ffffff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px !important;
            // margin-right: 12px;
            flex-shrink: 0;

        }

        .rule_text {
            font-size: 16px;
            // color: #666;
            // line-height: 1.5;
        }
    }
    .line_bottom2{
         border-bottom: 1px solid #ddd;
    }
}

/* 提交按钮 */
.submit_btn {
    width: 100%;
    height: 48px;
    background: #1890ff;
    color: #ffffff;
    border: none;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    transition: background-color 0.3s;
    
    &.disabled {
        background: #d9d9d9;
        cursor: not-allowed;
        opacity: 0.6;
    }

    &:hover {
        background: #40a9ff;
    }
}

/* 底部导航栏样式已移至FooterTab组件 */
</style>